<template>
  <cst-page-template :hide-menu="true" class="change-order-overview-page">
    <header-menu />
    <div class="change-order-overview-page__wrapper">
      <pcqm-dashboard-warning-container />
      <div class="o-row-full dashboard-header">
        <div class="row container">
          <div class="column">
            <existing-kom-number />
          </div>
          <div v-if="isBulkOrderButtonVisible" class="column">
            <bulk-upload />
          </div>
        </div>
      </div>
      <change-order-overview />
    </div>
  </cst-page-template>
</template>

<script>
import CstPageTemplate from '@/templates/CstPageTemplate.vue'
import ChangeOrderOverview from '@/components/changeOrder/presentational/organisms/changeOrderOverview/ChangeOrderOverview.vue'
import ExistingKomNumber from '@/components/changeOrder/presentational/molecules/komnumber/ExistingKomNumber.vue'
import PcqmDashboardWarningContainer from '@/components/generic/presentational/molecules/pcqmDashboardWarningContainer/PcqmDashboardWarningContainer.vue'
import BulkUpload from '@/components/changeOrder/presentational/molecules/Bulkupload/BulkUpload.vue'
import { mapGetters } from 'vuex'
import HeaderMenu from '@/components/generic/presentational/molecules/headerMenu/HeaderMenu.vue'

export default {
  components: {
    BulkUpload,
    CstPageTemplate,
    ExistingKomNumber,
    ChangeOrderOverview,
    PcqmDashboardWarningContainer,
    HeaderMenu,
  },
  computed: {
    ...mapGetters({
      dealerSettings: 'user/dealerSettings',
    }),
    isBulkOrderButtonVisible() {
      return this.dealerSettings.isImporter
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 0 1.5rem;
  display: grid;
  row-gap: 20px;
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}

.dashboard-header {
  padding-top: 1rem;
  padding-bottom: 1.5rem;
  background: $gray-lightest;
}
</style>
